import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormService {
  private http = inject(HttpClient);

  getCompleteOrderForm(): Observable<FormlyFieldConfig[]> {
    return this.http.get<FormlyFieldConfig[]>('/form-generator/form');
  }

  getOrderFormFilteredByArticleNumbers(articleNumbers: number[]): Observable<FormlyFieldConfig[]> {
    return this.http.get<FormlyFieldConfig[]>('/form-generator/form', {
      params: { articles: articleNumbers.toString() },
    });
  }
}
